import { RefObject } from 'react';
import { COLUMN_NAME_ATTR } from '../../constants';

const SMOOTH_DURATION_MS = 400;

// Smoothly scrolls the column header into view (horizontally within the grid, vertically within the page), then calls onComplete.
export const scrollGridToColumnSmooth = (
  gridRef: RefObject<HTMLElement | any>,
  columnName: string,
  onComplete?: () => void
): void => {
  const wrapper =
    gridRef.current?.querySelector('.p-virtualscroller') ??
    gridRef.current?.querySelector('.p-datatable-wrapper');
  const headerCell = gridRef.current?.querySelector(
    `[${COLUMN_NAME_ATTR}="${CSS.escape(columnName)}"]`
  ) as HTMLElement | null;

  if (!headerCell) {
    onComplete?.();
    return;
  }

  const cellRect = headerCell.getBoundingClientRect();
  const wrapperRect = wrapper?.getBoundingClientRect();

  // Horizontal range is the grid wrapper; vertical range is the page viewport (a subset grid can sit below the fold).
  const horizontalVisible = wrapperRect
    ? cellRect.left >= wrapperRect.left && cellRect.right <= wrapperRect.right
    : true;
  const verticalVisible =
    cellRect.top >= 0 && cellRect.bottom <= window.innerHeight;

  if (horizontalVisible && verticalVisible) {
    onComplete?.();
    return;
  }

  // block: 'center' leaves room below the header so the filter overlay opens inside the viewport.
  headerCell.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'center',
  });
  setTimeout(() => onComplete?.(), SMOOTH_DURATION_MS);
};
